import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConnectionTokenService } from '@rift/service/connection/ConnectionToken.Service';
import { RiftRestApiService } from '@rift/service/restapi/base/RiftRestApi.Service';
import { ConfigurationService } from '@shared/service/configuration/Configuration.Service';
import { ProcessMonitorServiceProcess } from '@shared/service/processmonitor/ProcessMonitor.Service.Process';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { WirelessPIRDataModel } from '@rift/models/restapi/WirelessPIRData.Model';

@Injectable()
export class RestApiWirelessPIRService extends RiftRestApiService {
    private _controller = 'wireless_pir';

    public constructor(
        _dialog: MatDialog,
        _connectionTokenService: ConnectionTokenService,
        _config: ConfigurationService,
        _httpClient: HttpClient) {
        super(_dialog, _config.riftV1RestApiBase, _httpClient, _connectionTokenService);
    }

    public getWirelessPIRData(serialNumber: string, process?: ProcessMonitorServiceProcess): Observable<WirelessPIRDataModel> {
        return this.get(`${this._controller}/${serialNumber}/get_data`, WirelessPIRDataModel, this.getTokenParams(), process).pipe(
            map(result => this.handleErrorOrThrow(result))
        );
    }
}
